import { IHeaderParams } from 'ag-grid-community';
import { Moment } from 'moment';
import React from 'react';
import styled from 'styled-components';
import { DateColumnHeaderCell } from '../../common/timesheet-table';

const HeaderWrapper = styled.div`
  height: var(--spacing-10);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export interface CustomHeaderParams {
  day: Moment;
}

export const CustomHeaderRenderer = (
  params: CustomHeaderParams & IHeaderParams,
) => {
  const { displayName, day } = params;

  return (
    <HeaderWrapper>
      {day ? <DateColumnHeaderCell date={day} /> : <div>{displayName}</div>}
    </HeaderWrapper>
  );
};
